import { useEffect } from "react";
import { getNestedValue, setNestedValue } from "../../../utils/object";
import { QRCODEModelEnum } from "../../../constants/readers-model";
import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";

export function PartialFormQrcode({ configuration, setConfiguration, setEditablePort, ...props }) {

   useEffect(() => {
      setEditablePort(true);
      if (!configuration) {
         setConfiguration({
            model: QRCODEModelEnum.EMBUTIR,
         });
      }
   }, []);

   function onChange(field, value) {
      const currentValue = getNestedValue(configuration, field);
      if (currentValue === value) return;
      setConfiguration(setNestedValue({ ...configuration }, field, value));
   }

   return (
      <div className="grid grid-cols-2 gap-2.5 w-full">
         <Select
            labelText="Modelo*"
            value={configuration?.model}
            onChange={({ target }) => {
               onChange('model', target.value)
            }}
            disabled={props.formMode === "consulta"}
            required={false}
            options={[
               { value: QRCODEModelEnum.EMBUTIR, text: 'Embutir' },
               { value: QRCODEModelEnum.SOBREPOR, text: 'Sobrepor' },
            ]}
         />
         <Input
            name="ignoreSameTagValueTime"
            type="number"
            id="ignoreSameTagValueTime"
            labelText="Tempo ignora tag de mesmo valor (s)"
            value={configuration?.ignoreSameTagValueTime}
            onChange={({ target }) => onChange('ignoreSameTagValueTime', target.value)}
            disabled={props.type === "consulta"}
            required={true}
         />
         <ToggleButton
            style={{ width: 'fit-content', paddingTop: '15px' }}
            label={`Modo Tag`}
            tooltipVisible={true}
            tooltipText="QRCode representa código de tag"
            onChange={(e) => onChange('tagMode', e.target.checked)}
            selected={configuration?.tagMode}
         />
      </div>
   );
}